
import { useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";

import DocumentList from "./DocumentList";
import AdminEditTypeSelect from "./AdminEditTypeSelect";


const DocumentManagementModal = ({ show, onClose, entityId, entityType, entityName, practiceName, practiceId}) => {

  const [selectedEditType, setSelectedEditType] = useState("PRACTICE");

    const handleEditTypeChanged = (editType) => {
      setSelectedEditType(editType);
    }

  return (
      <Modal show={show} onHide={onClose} dialogClassName={"modal-850"}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Documents for <b>{entityName}</b>{(selectedEditType === "PRACTICE") ? ` for ${practiceName}` : ""}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table className="table-borderless table-sm">
            <tbody>
              <tr>
                <td><AdminEditTypeSelect disabled={false} selectedEditType={selectedEditType} handleEditTypeChanged={handleEditTypeChanged} practiceName={practiceName} /></td>
              </tr>
            </tbody>
          </Table>
          <DocumentList key={`${entityId}-${selectedEditType}-${practiceId}`} entityId={entityId} entityType={entityType} canEdit={true} isRevenueTeamSpanningFile={selectedEditType==="GLOBAL"} isPracticeSpecificFile={selectedEditType==="PRACTICE"} practiceId={practiceId}/>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
          <Button onClick={onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
  
  
  export default DocumentManagementModal;